import moment from 'moment-timezone'
export const restSinNegocio = (obj) => {
  return obj.id.replace(obj.negocio + '-', '');
}

export const restSinNegocio2 = (rest, neg) => {
  return rest.replace(neg + '-', '');
}

export const restSinNegocioParams = (rest, negocio) => {
  return rest.replace(negocio + '-', '');
}
export const formatearCocinas = (obj, cocinas) => {
  let res = "";
  if (cocinas != undefined) {
    obj.forEach((e, i) => {
      let separador = i == obj.length - 1 ? "" : " • ";
      let index = cocinas.findIndex((x) => { return x.id == e })
      res += (app.$mostrarIdioma(cocinas[index].nombre) + separador);
    })
  }
  return res;
}

export const horariosToArray = (rest) => {
  if (rest && rest.horarios) {
    let arrayDomicilio = [];
    let arrayRecoger = [];
    let arrayApertura = [];
    rest.horarios.semana.forEach((d, i) => {
      let foundD = rest.horarios.tipos.find(t => d.domicilio === t.nombre)
      arrayDomicilio[i] = (foundD) ? foundD.rangos : []
      let foundR = rest.horarios.tipos.find(t => d.recoger === t.nombre)
      arrayRecoger[i] = (foundR) ? foundR.rangos : []
      let foundA = rest.horarios.tipos.find(t => d.apertura === t.nombre)
      arrayApertura[i] = (foundA) ? foundA.rangos : []

    })
    return {
      domicilio: arrayDomicilio,
      recoger: arrayRecoger,
      apertura: arrayApertura
    };
  } else {
    return [
      [], [], [], [], [], [], []
    ]
  }
}
export const hoy = (obj) => {
  let tz =
    obj && obj.confGeneral && obj.confGeneral.zonaHoraria
      ? obj.confGeneral.zonaHoraria
      : "Europe/Madrid";
  let r = moment().tz(tz).day();
  return r - 1 < 0 ? 6 : r - 1;
}

export const horariosToArrayHoy = (rest) => {
  let array = horariosToArray(rest);
  let hoyR = hoy(rest);
  return {
    recoger: array.recoger ? array.recoger[hoyR] : [],
    domicilio: array.domicilio ? array.domicilio[hoyR] : [],
    apertura: array.apertura ? array.apertura[hoyR] : [],
  }
}
export const horariosToArrayHoyFranjaAhora = (rest) => {
  let tz =
    rest && rest.confGeneral && rest.confGeneral.zonaHoraria
      ? rest.confGeneral.zonaHoraria
      : "Europe/Madrid";
  let array = horariosToArrayHoy(rest);
  let ahora = moment().tz(tz);
  let recoger = null;
  let domicilio = null;
  let recogerAbreEn = null;
  let domicilioAbreEn = null;

  if (Array.isArray(array.recoger)) {
    recoger = array.recoger.map(f => {
      let inicio = moment(f.inicio, 'HH:mm').tz(tz);
      let fin = moment(f.fin, 'HH:mm').tz(tz);
      if (inicio > fin) fin.add(1, 'days');
      let dentro = false;
      let abreEn = null;
      if (ahora > inicio && ahora < fin) {
        dentro = true;
      } else if (ahora < inicio) {//está cerrado, buscamos hora de apertura
        abreEn = inicio.format('HH:mm');
      }
      return {
        inicio: f.inicio,
        fin: f.fin,
        dentro: dentro,
        abreEn: abreEn,
      }
    })
    let foundAbreEn = recoger.find(r => !!r.abreEn);
    recogerAbreEn = foundAbreEn ? foundAbreEn.abreEn : null

  }
  if (Array.isArray(array.domicilio)) {
    domicilio = array.domicilio.map(f => {
      let inicio = moment(f.inicio, 'HH:mm').tz(tz);
      let fin = moment(f.fin, 'HH:mm').tz(tz);
      if (inicio > fin) fin.add(1, 'days');
      let dentro = false;
      let abreEn = null;
      if (ahora > inicio && ahora < fin) {
        dentro = true;
      } else if (ahora < inicio) {//está cerrado, buscamos hora de apertura
        abreEn = inicio.format('HH:mm');
      }
      return {
        inicio: f.inicio,
        fin: f.fin,
        dentro: dentro,
        abreEn: abreEn,
      }
    })
    let foundAbreEnD = domicilio.find(r => !!r.abreEn);
    domicilioAbreEn = foundAbreEnD ? foundAbreEnD.abreEn : null
  }

  return {
    recoger: recoger,
    recogerAbreEn: recogerAbreEn,
    domicilio: domicilio,
    domicilioAbreEn: domicilioAbreEn,
  }
}